import { z } from 'zod';
/** One schema, two consumers — the client cannot validate differently. */
export const loginSchema = z.object({
    email: z.string().trim().toLowerCase().email('Enter a valid email address.'),
    password: z.string().min(1, 'Enter your password.'),
    /**
     * The admin console collects a 6-digit code. Accepted here so the field is a
     * declared part of the contract rather than a value Zod quietly strips —
     * but NOT yet verified anywhere: no admin has a 2FA secret enrolled, so a
     * correct email and password still signs in without it.
     */
    authCode: z
        .string()
        .trim()
        .regex(/^\d{6}$/, 'Enter the 6-digit code from your authenticator.')
        .optional(),
});
export const PASSWORD_MIN = 10;
export const passwordSchema = z
    .string()
    .min(PASSWORD_MIN, `Use at least ${PASSWORD_MIN} characters.`)
    .max(128, 'That password is too long.');
export const changePasswordSchema = z
    .object({
    currentPassword: z.string().min(1, 'Enter your current password.'),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
})
    .refine((v) => v.newPassword === v.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Both passwords must match.',
});
/** What a person may change about themselves. Not email — that is the login. */
export const updateProfileSchema = z.object({
    name: z.string().trim().min(2, 'Enter your full name.').max(120).optional(),
    phone: z.string().trim().max(20).nullable().optional(),
});
/**
 * Four to eight digits. Short enough to be worth typing, which is also short
 * enough to be guessed — so a PIN is only ever accepted alongside the device
 * cookie issued when it was set.
 */
export const pinSchema = z
    .string()
    .regex(/^[0-9]{4,8}$/, 'A PIN is 4 to 8 digits.');
export const setPinSchema = z
    .object({
    currentPassword: z.string().min(1, 'Enter your password to confirm.'),
    pin: pinSchema,
    confirmPin: z.string(),
})
    .refine((v) => v.pin === v.confirmPin, {
    path: ['confirmPin'],
    message: 'Both PINs must match.',
});
/** No email: the device cookie says whose PIN this is. */
export const pinLoginSchema = z.object({ pin: pinSchema });
//# sourceMappingURL=auth.schema.js.map